import { makeStyles } from "@mui/styles";
import { SURVEY_SPACING, SURVEY_MIXINS } from "../../shared/theme-constants";
// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const useCommentOnlyQuestionStyles = makeStyles(() => ({
  container: {
    marginTop: SURVEY_SPACING.QUESTION_MARGIN_TOP,
  },
  formLabel: {
    paddingBottom: SURVEY_SPACING.LABEL_PADDING_BOTTOM,
  },
  questionText: SURVEY_MIXINS.questionLabel,
  requiredAsterisk: SURVEY_MIXINS.requiredAsterisk,
  textareaError: SURVEY_MIXINS.errorBorder,
}));
